import useDialog from '@/natives/libs/hooks/useDialog';
import useLoading from '@/natives/libs/hooks/useLoading';
import useMessage from '@/natives/libs/hooks/useMessage';
import { isAccountNeedUpgrade } from '@pro/common/dao/upgrade-strategy.js';
const elJoinOurCompanyDialog = document.querySelector('.join-our-company__dialog');
import useEventBus from '@/natives/libs/hooks/useEventBus';
import api from '../api';
import i18n from '@/natives/libs/i18n';
import getRoute from '@pro/common/utils/getRoute';
const route = getRoute();

//打开加入我们弹窗
// 原代码此种弹窗一定是SSO 注册和登录

function openJoinOurCompany() {
  const dialogJoinOurCompany = useDialog(elJoinOurCompanyDialog);
  elJoinOurCompanyDialog.querySelector('.invite-text').innerText = i18n
    .t('company_invite')
    .replace('{0}', sessionStorage.getItem('invitedName'));
  elJoinOurCompanyDialog.style.removeProperty('display');
  const loginButton = elJoinOurCompanyDialog.querySelector('.join-our-company__register');
  loginButton.addEventListener('click', () => {
    gotoOneHikPage('register');
    dialogJoinOurCompany.close();
  });

  const registerButton = elJoinOurCompanyDialog.querySelector('.join-our-company__login');
  registerButton.addEventListener('click', () => {
    gotoOneHikPage('login');
    dialogJoinOurCompany.close();
  });

  dialogJoinOurCompany.open();
}

function gotoOneHikPage(type) {
  const invitedEmail = sessionStorage.getItem('invitedEmail'); //邀请员工URL invitedEmail
  const invitedToken = sessionStorage.getItem('invitedToken'); //邀请员工URL invitedToken
  const invitedCompany = sessionStorage.getItem('inviteCompanyId'); //邀请员工URL invitedCompany
  const params = {
    token: invitedToken,
    email: invitedEmail,
    company: invitedCompany,
    ticket: route.query.ticket
  };
  // 将邮箱标记为员工账号 异步发送请求，不影响下一个页面加载
  api.markEmailAsEmployee(params);
  if (type === 'login') {
    const toLoginEvent = useEventBus('to-login');
    toLoginEvent.emit('onehikid');
  } else {
    const toRegisterEvent = useEventBus('to-register');
    toRegisterEvent.emit('onehikid');
  }
}

function checkCountry() {
  const countryOrRegionIndex = Number(route.query.country);
  sessionStorage.setItem('inviteCompanyId', route.query.company);
  sessionStorage.setItem('invitedToken', route.query.token);
  sessionStorage.setItem('invitedName', decodeURIComponent(route.query.name));
  sessionStorage.setItem('invitedType', route.query.type);
  sessionStorage.setItem('invitedCountry', countryOrRegionIndex);
  sessionStorage.setItem('invitedEmail', decodeURIComponent(route.query.email));
  const upgradeStrategy = isAccountNeedUpgrade(countryOrRegionIndex);
  if (upgradeStrategy > 0) {
    openJoinOurCompany();
  } else {
    window.location.href = '/#/invitedRegisterAfter?hpc=true';
  }
}

async function checkUrlValid(email, company, token) {
  const params = {
    email,
    company,
    token
  };
  const loading = useLoading();
  const [data, err] = await api.checkUrlValid(params).finally(() => {
    loading.close();
  });
  if (data) {
    checkCountry();
  } else {
    sessionStorage.clear();
    useMessage({
      title: i18n.t('error'),
      message: i18n.t(err.errorCode),
      type: 'error'
    }).finally(() => {
      window.location.href = `/lp/index.html?hash=${ route.query.hash}`;
    });
  }
}

export default async function startInvitedEmployee() {
  const { email, token, company } = route.query;
  email && company && token && (await checkUrlValid(email, company, token));
}
